import { Navigate, useLocation } from "react-router-dom";
import OnboardingForm from "./OnboardingForm";
import { FC } from "react";
import { OnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";

// Interface for the state passed to OnboardingForm
interface OnboardingFormState {
  onboardingStatus: OnboardingStatusEnum;
  merchantName: string;
  merchantEmail: string;
  merchantId?: number;
}

const OnboardingFormWrapper: FC = () => {
  const { state } = useLocation();
  const { onboardingStatus, merchantName, merchantEmail, merchantId } =
    (state as OnboardingFormState) || {};

  if (!state) {
    // Redirect to /onboarding if no state is provided
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <OnboardingForm
      onboardingStatus={onboardingStatus}
      merchantName={merchantName}
      merchantEmail={merchantEmail}
      merchantId={merchantId}
    />
  );
};

export default OnboardingFormWrapper;
